
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unified",
      function () {
        return require("private-next-pages/unified.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/unified"])
      });
    }
  